export default __webpack_public_path__ + "static/hero-0d2986c7b3de0bc1b27a9b5d6ff1b32d.png";